import { render } from "./target_history_form.vue?vue&type=template&id=54c9f906&scoped=true"
import script from "./target_history_form.vue?vue&type=script&lang=js"
export * from "./target_history_form.vue?vue&type=script&lang=js"

import "./target_history_form.vue?vue&type=style&index=0&id=54c9f906&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c9f906"]])

export default __exports__